import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=261cd2ae&scoped=true&"
import script from "./HeaderButtons.vue?vue&type=script&lang=js&"
export * from "./HeaderButtons.vue?vue&type=script&lang=js&"
import style0 from "./HeaderButtons.vue?vue&type=style&index=0&id=261cd2ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261cd2ae",
  null
  
)

export default component.exports